import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, BarChart3, FileText, Settings, LogOut, BookOpen } from 'lucide-react';
import { loadAvatar } from '../UtilityComponents/AvatarService';
import DashboardStyle from '../styles&pics/DashboardStyle';

const Dashboard = ({ user, handleLogout }) => {
  const navigate = useNavigate();
  const [avatar, setAvatar] = useState('');

  useEffect(() => {
    const loadUserAvatar = async () => {
      const avatarData = await loadAvatar(user);
      if (avatarData) {
        setAvatar(avatarData);
      }
    };
    loadUserAvatar();

    const handleAvatarChange = async () => {
      const avatarData = await loadAvatar(user);
      setAvatar(avatarData || '');
    };

    window.addEventListener('avatarChange', handleAvatarChange);
    return () => window.removeEventListener('avatarChange', handleAvatarChange);
  }, [user]);

  const menuItems = [
    {
      icon: <BarChart3 />,
      title: 'Στατιστικά',
      description: 'Δείτε την πρόοδό σας και τα αποτελέσματά σας',
      path: '/statistics',
      color: '#87CEFA'
    },
    {
      icon: <FileText />,
      title: 'Προσομοίωση Εξετάσεων',
      description: 'Δοκιμάστε τις γνώσεις σας με πλήρεις εξετάσεις',
      path: '/exams',
      color: '#673ab7'
    },
    {
      icon: <BookOpen />,
      title: 'Εξάσκηση',
      description: 'Εξασκηθείτε με ερωτήσεις ανά κατηγορία',
      path: '/practice',
      color: '#ff1493'
    },
    {
      icon: <Settings />,
      title: 'Ρυθμίσεις',
      description: 'Διαχείριση λογαριασμού και προτιμήσεων',
      path: '/settings',
      color: '#d4af37'
    }
  ];

  return (
    <>
      <DashboardStyle />
      <div className="dashboard-page">
        <div className="dashboard-container">
          <div className="dashboard-welcome">
            <div className="welcome-content">
              {avatar ? (
                <img src={avatar} alt="Avatar" className="welcome-avatar" />
              ) : (
                <User className="welcome-icon" />
              )}
              <div className="welcome-text">
                <h1 className="dashboard-title">Dashboard του {user}</h1>
                <p>Τι θα ήθελες να κάνεις σήμερα;</p>
              </div>
            </div>
          </div>

          <div className="dashboard-menu">
            {menuItems.map((item, index) => (
              <div
                key={index}
                className="menu-item"
                onClick={() => navigate(item.path)}
                style={{ '--item-color': item.color }}
              >
                <div className="menu-icon" style={{ color: item.color }}>
                  {item.icon}
                </div>
                <div className="menu-content">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}

            <div className="menu-item logout-item" onClick={handleLogout}>
              <div className="menu-icon" style={{ color: '#ef4444' }}>
                <LogOut />
              </div>
              <div className="menu-content">
                <h3>Αποσύνδεση</h3>
                <p>Έξοδος από τον λογαριασμό σας</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
